// Shared utility for resolving themed colors in Hotwire Native bridge components.
// Automatically selects light or dark color based on system preference.

/**
 * Resolves the appropriate color based on system color scheme preference.
 *
 * @param {string|null} lightColor - Hex color for light mode (e.g., "#1a1a1a")
 * @param {string|null} darkColor - Hex color for dark mode (e.g., "#e8e4df")
 * @returns {string|null} The resolved color, or null if neither provided
 *
 * @example
 * // In a bridge controller:
 * const color = resolveThemeColor(
 *   element.bridgeAttribute("light-color"),
 *   element.bridgeAttribute("dark-color")
 * )
 */
export function resolveThemeColor(lightColor, darkColor) {
  if (!lightColor && !darkColor) return null

  const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches
  return isDark ? (darkColor || lightColor) : (lightColor || darkColor)
}
